import React from "react";

const Steps = () => {
  const stepsData = [
    {
      number: 1,
      title: "Langkah 1",
      description: "Klik mulai tes dan isi biodata kamu",
    },
    {
      number: 2,
      title: "Langkah 2",
      description: "Mulai test dan Kerjakan test dengan benar",
    },
    {
      number: 3,
      title: "Langkah 3",
      description: "Lihat hasil akhir dan skor kamu",
    },
    {
      number: 4,
      title: "Langkah 4",
      description: "Dapatkan rekomendasi rencana belajar sesuai level dan ikuti kelasnya.",
    },
  ];

  return (
    <section className="bg-[#C91B06] px-6 py-12 text-[#FFF7EB] sm:px-10 sm:py-16 md:px-14 lg:px-16 lg:py-20">
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto mb-10 w-fit rounded-full bg-[#FFF7EB] px-8 py-2">
          <p className="st-font-body text-[10px] font-bold tracking-[0.2em] text-[#C91B06] sm:text-[11px]">
            -- HOW TO DO? --
          </p>
        </div>

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-8">
          <div className="flex flex-col justify-between">
            <h2 className="st-font-display text-4xl leading-[1.02] sm:text-5xl lg:text-[64px]">
              <span className="block italic">Step by Step</span>
              <span className="block font-medium not-italic">Placement Test</span>
            </h2>

            <p className="st-font-body mt-8 max-w-[360px] text-xl font-bold leading-[1.2] sm:text-2xl lg:mt-14 lg:text-[34px]">
              Ikuti langkah-langkah
              <br />
              berikut untuk mulai:
            </p>
          </div>

          <div className="relative pl-9 sm:pl-12">
            <div className="absolute bottom-3 left-2 top-3 w-[2px] bg-[#FFD8D0] sm:left-4" />

            <div className="space-y-9 sm:space-y-11">
              {stepsData.map((step) => (
                <div key={step.number} className="relative">
                  <span className="absolute left-[-35px] top-2 h-4 w-4 rounded-full bg-[#FFF7EB] sm:left-[-39px]" />
                  <h3 className="st-font-body text-2xl font-bold leading-tight sm:text-3xl lg:text-[44px]">
                    {step.title}
                  </h3>
                  <p className="st-font-body mt-2 max-w-[700px] text-base leading-[1.25] text-[#FFF1ED] sm:text-lg lg:text-[28px]">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Steps;
